import React from "react";
import { styled, Stack } from "@mui/material";

const colors: any = {
  green: "#B1D238",
  blue: "#40A3FF",
  golden: "#CFBD1B",
  platinum: "#D6D6D6",
  silver: "#12121280",
};

const StyledChip = styled(Stack, {
  shouldForwardProp: (prop) =>
    prop !== "selectedColor" && prop !== "borderPlacement",
  name: "Chip",
})<{
  selectedColor?: string;
  borderPlacement?:
    | "all"
    | "bottom-left"
    | "bottom-right"
    | "top-right"
    | "top-left"
    | undefined;
  theme?: any;
}>(({ selectedColor, borderPlacement }: any) => ({
  backgroundColor: selectedColor ? colors[selectedColor] : colors["primary"],
  fontWeight: 600,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  textTransform: "capitalize",
  borderRadius:
    borderPlacement === "all"
      ? "9px"
      : `${borderPlacement === "top-left" ? "9px" : 0} ${
          borderPlacement === "top-right" ? "9px" : 0
        } ${borderPlacement === "bottom-right" ? "9px" : 0} ${
          borderPlacement === "bottom-left" ? "9px" : 0
        }`,
}));

export interface BadgeVisualInterface {
  color?: string;
  label: string;
  borderPlacement?:
    | "all"
    | "bottom-left"
    | "bottom-right"
    | "top-right"
    | "top-left"
    | undefined;
}

const BadgeVisual: React.FC<BadgeVisualInterface> = ({
  label,
  color = "green",
  borderPlacement = "top-left",
}: BadgeVisualInterface) => {
  return (
    <StyledChip
      selectedColor={color}
      borderPlacement={borderPlacement}
      alignItems="center"
      justifyContent="center"
      padding="7px 16px"
      width="fit-content"
      maxWidth="115px"
      textAlign="center"
    >
      {label}
    </StyledChip>
  );
};

export default BadgeVisual;
